if (GT?.agent?.os?.family?.includes('Mac')) {
  document.getElementsByTagName('html')[0].classList.add('mac-swipe-action-scroll-fix');
}
